import { render } from "./DesktopToggle.vue?vue&type=template&id=af518266&scoped=true"
import script from "./DesktopToggle.vue?vue&type=script&lang=js"
export * from "./DesktopToggle.vue?vue&type=script&lang=js"

import "./DesktopToggle.vue?vue&type=style&index=0&id=af518266&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af518266"]])

export default __exports__